/* Maison Caviar — theme.js */
(function() {
  'use strict';

  /* ── Live cart count ─────────────────────────────────────────── */
  window.__updateCartCount = async function() {
    try {
      var r = await fetch('/cart.js');
      var data = await r.json();
      document.querySelectorAll('.cart-badge').forEach(function(b) {
        b.textContent = data.item_count;
        b.style.display = data.item_count > 0 ? 'flex' : 'none';
      });
    } catch (_) {}
  };

  /* Run on load */
  window.__updateCartCount();

})();
